module.exports = __webpack_public_path__ + "img/q5-1-3@2x.1bc8a31c.png";